const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" fill="none" viewBox="0 0 18 17">
  <path stroke="#1A1A1A" strokeWidth="2" d="M1.507 15.517 15.793 1.231m-13.586.051 14.286 14.286" />
</svg>



export default CloseIcon;
